import {
  FILTER_TYPE_TEXT,
  FILTER_TYPE_INTEGER,
  FILTER_TYPE_MULTISELECT,
  FILTER_TYPE_DATE,
  FILTER_TYPE_SWITCH
} from "@/store/system/helpers";
import store from "@/store";

export function getBlankCriteria() {
  return {
    status: [],
    createdFrom: null,
    createdTo: null,
    dueFrom: null,
    dueTo: null,
    levyCollectionType: [],
    levyCollectionYear: null,
    paymentStatus: [],
    providerName: null,
    providerCode: null,
    sapCustomerIdentifier: null,
    sapDocumentIdentifier: null,
    shouldBeSent: null
  };
}

export function getSearchFilters() {
  return [
    {
      text: "Status",
      value: "status",
      type: FILTER_TYPE_MULTISELECT,
      items: store.state.lookups.data.invoiceStatuses,
      default: true
    },
    {
      text: "Payment status",
      value: "paymentStatus",
      type: FILTER_TYPE_MULTISELECT,
      items: store.state.lookups.data.paymentStatuses
    },
    { text: "SAP document ID", width: 6, value: "sapDocumentIdentifier", type: FILTER_TYPE_INTEGER },
    { text: "SAP customer ID", width: 6, value: "sapCustomerIdentifier", type: FILTER_TYPE_INTEGER },
    { text: "Due on or after", width: 6, value: "dueFrom", type: FILTER_TYPE_DATE },
    { text: "Due on or before", width: 6, value: "dueTo", type: FILTER_TYPE_DATE },
    { text: "Created on or after", width: 6, value: "createdFrom", type: FILTER_TYPE_DATE },
    { text: "Created on or before", width: 6, value: "createdTo", type: FILTER_TYPE_DATE },
    { text: "Provider name", width: 8, value: "providerName", type: FILTER_TYPE_TEXT },
    { text: "Provider code", width: 4, value: "providerCode", type: FILTER_TYPE_INTEGER },
    {
      text: "Levy collection type",
      value: "levyCollectionType",
      width: 6,
      type: FILTER_TYPE_MULTISELECT,
      items: store.state.lookups.data.levyCollectionTypes
    },
    { text: "Levy collection year", width: 6, value: "levyCollectionYear", type: FILTER_TYPE_INTEGER },
    { text: "Invoice raised but not sent", value: "shouldBeSent", type: FILTER_TYPE_SWITCH }
  ];
}

export function getBlankRecord() {
  return {
    amount: null,
    assignedPaymentStatus: null,
    bpayReferenceNumber: null,
    cleared: null,
    created: null,
    due: null,
    id: null,
    lastReconciled: null,
    levyCollection: null,
    levyCollectionId: null,
    levyCollectionStatus: null,
    links: [],
    outstandingAmount: null,
    paymentStatus: null,
    provider: null,
    providerId: null,
    providerLatePaymentDays: null,
    providerStatus: null,
    sapCustomerIdentifier: null,
    sapDocumentIdentifier: null,
    status: null,
    warnings: []
  };
}

export function getBlankReconciliationRecord() {
  return {
    status: null,
    clearingDate: null,
    outstandingBalance: null
  };
}

export function getBlankTransactionListing(invoiceId) {
  return {
    invoiceId,
    loading: false,
    loaded: false,
    data: []
  };
}

export function getBlankDueRecord() {
  return { due: null };
}
